/**
 * 时间日期相关操作
 */


/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成 2018/09/23 11:54:16
 * @param datetime 国际化日期格式
 */
export function format(datetime) {
  return formatWithSeperator(datetime, "/", ":");
}

export function formatDate(datetime) {
  return formatWithSeperator(datetime, "-", "");
}

export function formatDateTime(datetime) {
  return formatWithSeperator(datetime, "-", ":");
}

/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成类似 2018/09/23 11:54:16
 * 可以指定日期和时间分隔符
 * @param datetime 国际化日期格式
 */
export function formatWithSeperator(datetime, dateSeprator, timeSeprator) {
  if (datetime != null && datetime !== '' && datetime !== '-' && datetime !== '--') {
    const dateMat = new Date(datetime);
    const year = dateMat.getFullYear();
    const month = leftpadNum(dateMat.getMonth() + 1, 2);
    const day = leftpadNum(dateMat.getDate(), 2);

    let timeFormat = year + dateSeprator + month + dateSeprator + day;
    if (timeSeprator !== '') {
      const hh = leftpadNum(dateMat.getHours(), 2);
      const mm = leftpadNum(dateMat.getMinutes(), 2);
      const ss = leftpadNum(dateMat.getSeconds(), 2);
      timeFormat += " " + hh + timeSeprator + mm + timeSeprator + ss;
    }
    return timeFormat;
  }
}

/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成类似 2018/09/23 11:54:16
 * 可以指定日期和时间分隔符
 * @param datetime 国际化日期格式
 */
export function formatHMS(datetime) {
  if (datetime != null) {
    datetime = datetime.replace(/-/g, "/");//解决在IE和safri浏览器显示NaNa的问题
    const dateMat = new Date(datetime);
    var hh = leftpadNum(dateMat.getHours(), 2);
    var mm = leftpadNum(dateMat.getMinutes(), 2);
    var ss = leftpadNum(dateMat.getSeconds(), 2);
    const timeFormat = hh + ":" + mm + ":" + ss;
    return timeFormat;
  }
}

export function leftpadNum(num, len) {
  if (num != null && num !== '') {
    if (parseInt(num) < 10) {
      num = "0" + num;
    }
  }
  return num;
}



// WEBPACK FOOTER //
// ./src/utils/datetime.js